export type BudgetView = 'budgeting' | 'agency';

export const budgetRouteNames = {
    budgeting: 'account.event.budget',
    agency: 'account.event.budget.agency',
} as const;

export const budgetRouteNameForPreference = (defaultBudgetView?: string, agencyBudgetEnabled = false): string => {
    return defaultBudgetView === 'agency' && agencyBudgetEnabled ? budgetRouteNames.agency : budgetRouteNames.budgeting;
};
